module.exports = __webpack_public_path__ + "static/media/59-park.aa6b1d2f.jpeg";